'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.everyFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/everyFromIndex.js
// module id = 368
// module chunks = 0